/**
 * phase-ui-compiler-tree-documents-pane — ONE normaliser for section-code
 * matching between the canonical tree and stored documents.
 *
 * Tree nodes key on m-prefixed UI codes ('m1.2', 'm3.2.P.5.1'); documents
 * store the bare eCTD numeric form in Classification / CtdSectionCode
 * ('1.2', '3.2.P.5.1'). Every join that compared them raw matched nothing,
 * so tree badges showed 0 and section clicks listed no documents for ANY
 * region (Sharon's 2026-07-17 Eupravia screenshot). Both sides of every
 * comparison go through this key.
 *
 * MIRRORED in src/lib/section-tree/canonical-trees.ts (backend) — keep the
 * two implementations byte-identical.
 */
export function sectionKey(code: string | null | undefined): string {
  if (!code) return '';
  return code.trim().toLowerCase().replace(/^m(?=\d)/, '');
}
